import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { imgSrc } from "@/lib/img";

export default function Orders() {
  const { user, API, authHeader, loading } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login?next=/orders"); return; }
    axios.get(`${API}/orders/mine`, { headers: authHeader() })
      .then(r => setOrders(r.data))
      .finally(() => setBusy(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading]);

  return (
    <div data-testid="orders-page" className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
      <div className="label-eyebrow">Account</div>
      <h1 className="font-display text-5xl md:text-6xl mt-3 mb-12">My Orders</h1>

      {busy ? <p className="text-sm text-[#5C5454]">Loading…</p> :
        orders.length === 0 ? (
          <div className="py-16 border-y border-[#E5DFD3] text-center">
            <p className="font-display text-2xl">No orders yet</p>
            <Link to="/shop" data-testid="orders-shop" className="inline-block mt-6 bg-[#6B1A24] text-[#FAFAF7] px-8 py-4 uppercase text-xs tracking-[0.25em]">Discover the collection</Link>
          </div>
        ) : (
          <div className="space-y-6">
            {orders.map(o => (
              <div key={o.id} className="border border-[#E5DFD3] p-6" data-testid={`order-${o.id}`}>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#5C5454]">Order</div>
                    <div className="font-mono text-sm mt-1">{o.id.slice(0, 8).toUpperCase()}</div>
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#5C5454]">Placed</div>
                    <div className="text-sm mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#5C5454]">Total</div>
                    <div className="font-display text-xl mt-1 tabular-nums">${o.total.toFixed(2)}</div>
                    {o.coupon_code && (
                      <div className="text-[10px] uppercase tracking-[0.2em] text-[#6B1A24] mt-1" data-testid={`order-coupon-${o.id}`}>
                        {o.coupon_code} · −${(o.discount || 0).toFixed(2)}
                      </div>
                    )}
                  </div>
                  <div>
                    <span className={`px-3 py-1 text-[10px] uppercase tracking-[0.2em] ${o.status === "paid" ? "bg-[#3A5A40] text-[#FAFAF7]" : o.status === "fulfilled" ? "bg-[#6B1A24] text-[#FAFAF7]" : "bg-[#EFEAE1] text-[#2D2626]"}`}>{o.status}</span>
                  </div>
                </div>
                <div className="mt-5 flex flex-wrap gap-3">
                  {o.items.map((i, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <div className="w-12 h-16 bg-[#F3EFEA]">{i.image && <img src={imgSrc(i.image)} alt="" className="w-full h-full object-cover" />}</div>
                      <div className="text-xs text-[#5C5454]">{i.name} · {i.size} × {i.quantity}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
